import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ProductService } from "../../services/product.service";
import { ProductsActions } from "./products.actions";
import { map, mergeMap, filter, withLatestFrom } from "rxjs/operators";
import { Store, select } from "@ngrx/store";
import { selectAllProducts } from "./products.selects";

@Injectable()
export class ProductsEffects {
    constructor(
        private actions$: Actions,
        private productService: ProductService,
        private store: Store
    ) {}

    loadProducts$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ProductsActions.loadProducts),
            withLatestFrom(this.store.pipe(select(selectAllProducts))),
            filter(([_, products]) => products === undefined),
            mergeMap(() =>
                this.productService.getProducts().pipe(
                    map((products) => ProductsActions.addProducts({ products }))
                )
            )
        )
    );
}